import { render, staticRenderFns } from "./InfoResponseIcon.vue?vue&type=template&id=4a351704&scoped=true"
import script from "./InfoResponseIcon.vue?vue&type=script&lang=js"
export * from "./InfoResponseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a351704",
  null
  
)

export default component.exports